var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Product } from '../../../models/product';
import FraimsyApi from '../../../core/api/fraimsy-api';
import ProductViewHero from './ProductViewHero';
import IconFeatureItem from '../../../components/IconFeatureItem';
import ImageContentBlock from '../../../components/ImageContentBlock';
import SmallIconFeatureContentBlock from '../../../components/SmallIconFeatureContentBlock';
import ProductsSliderContentBlock from '../../../components/ProductsSliderContentBlock';
import ProductDimensionsContentBlock from './ProductDimensionsContentBlock';
var PhotoBoxView = /** @class */ (function (_super) {
    __extends(PhotoBoxView, _super);
    function PhotoBoxView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            products: [],
            cartItem: null,
        };
        _this.sizes = {
            '4-canvas-prints': '8 x 10 inch: $ 55',
            '6-canvas-prints': '12 x 12 inch: $ 75',
            '5-canvas-prints': '16 x 20 inch: $ 115',
        };
        _this.handleSize = function (ev) {
            var product = _this.state.products.find(function (item) {
                return item.slug === ev.target.value;
            });
            if (!product) {
                return;
            }
            _this.setState({ cartItem: product });
        };
        return _this;
    }
    PhotoBoxView.prototype.componentDidMount = function () {
        this.fetchProducts();
    };
    PhotoBoxView.prototype.render = function () {
        if (!this.state.products || !this.state.cartItem) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "l-container" },
                React.createElement(ProductViewHero, { item: this.props.item, cartItem: this.state.cartItem, images: [
                        "/images/products/hero/" + this.props.item.id + "/1.jpg",
                    ], sizes: this.sizes, sizeHandler: this.handleSize },
                    React.createElement("div", null,
                        React.createElement(IconFeatureItem, { image: "/images/products/features/retro-look.svg", title: "product_view.item4.features1.title", content: "product_view.item4.features1.content" }),
                        React.createElement(IconFeatureItem, { image: "/images/products/features/blindframed.svg", title: "product_view.item4.features2.title", content: "product_view.item4.features2.content" }),
                        React.createElement(IconFeatureItem, { image: "/images/products/features/high-quality-canvas.svg", title: "product_view.item4.features3.title", content: "product_view.item4.features3.content" }))),
                React.createElement(ProductDimensionsContentBlock, { image: "/images/canvas-dimensions.png?v3", dimensions: [
                        'canvas_dimensions.item1',
                        'canvas_dimensions.item2',
                        'canvas_dimensions.item3',
                    ], title: "canvas_dimensions.title", title2: "canvas_dimensions.subtitle", content: "canvas_dimensions.content" }),
                React.createElement("div", { className: "h-margin-top--md-40" },
                    React.createElement(ImageContentBlock, { image: "/images/products/canvas/seamless-sophistication.jpg?v3", title1: "product_view.item4.section2.title", title2: "product_view.item4.section2.subtitle", content: "product_view.item4.section2.content" }),
                    React.createElement(ImageContentBlock, { image: "/images/products/canvas/golden-standard.jpg?v3", title1: "product_view.item4.section3.title", title2: "product_view.item4.section3.subtitle", content: "product_view.item4.section3.content", order: "content-image" }),
                    React.createElement(ImageContentBlock, { image: "/images/products/canvas/printing-process.jpg?v3", content: "product_view.item4.section4.content" }))),
            React.createElement("div", { className: "h-padding-top--40 h-padding-top--md-60" },
                React.createElement(SmallIconFeatureContentBlock, { items: [
                        {
                            image: '/images/products/features/recycled-box.svg',
                            title: 'product_view.bottom_features.item1.content',
                        },
                        {
                            image: '/images/products/features/natural-glue.svg',
                            title: 'product_view.bottom_features.item2.content',
                        },
                        {
                            image: '/images/products/features/recycled-paper.svg',
                            title: 'product_view.bottom_features.item3.content',
                        },
                    ] })),
            React.createElement(ProductsSliderContentBlock, { items: [1, 2], title: "product_view.other_products.title", subtitle: "product_view.other_products.subtitle" })));
    };
    PhotoBoxView.prototype.fetchProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            FraimsyApi.get("products/4-canvas-prints"),
                            FraimsyApi.get("products/5-canvas-prints"),
                            FraimsyApi.get("products/6-canvas-prints"),
                        ])];
                    case 1:
                        response = _a.sent();
                        products = [];
                        response.forEach(function (response) {
                            products.push(new Product(response.data.data));
                        });
                        this.setState({ products: products });
                        this.setState({ cartItem: products[0] });
                        return [2 /*return*/];
                }
            });
        });
    };
    return PhotoBoxView;
}(React.Component));
export default PhotoBoxView;
